// Conversion d'un nombre en lettres françaises (orthographe simplifiée).
// Couvre 0 à 999 999 999 — largement suffisant pour des montants de contrat.

const UNITS = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf',
  'dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];

const TENS = ['', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante', 'quatre-vingt', 'quatre-vingt'];

function below100(n: number): string {
  if (n < 20) return UNITS[n];
  const t = Math.floor(n / 10);
  const u = n % 10;
  if (t === 7 || t === 9) {
    const base = TENS[t];
    const rest = below100(10 + u);
    return base + (t === 7 ? (u === 1 ? ' et ' : '-') : '-') + rest;
  }
  let s = TENS[t];
  if (u === 0) {
    if (t === 8) s += 's';
    return s;
  }
  if (u === 1 && t !== 8) return s + ' et un';
  return s + '-' + UNITS[u];
}

function below1000(n: number): string {
  if (n < 100) return below100(n);
  const c = Math.floor(n / 100);
  const r = n % 100;
  let s = c === 1 ? 'cent' : UNITS[c] + ' cent';
  if (r === 0) {
    if (c > 1) s += 's';
    return s;
  }
  return s + ' ' + below100(r);
}

export function numberToFrenchWords(input: number): string {
  if (!Number.isFinite(input)) return '';
  const n = Math.floor(Math.abs(input));
  if (n === 0) return 'zéro';

  const millions = Math.floor(n / 1_000_000);
  const thousands = Math.floor((n % 1_000_000) / 1000);
  const rest = n % 1000;

  const parts: string[] = [];
  if (millions > 0) {
    parts.push((millions === 1 ? 'un million' : below1000(millions) + ' millions'));
  }
  if (thousands > 0) {
    parts.push(thousands === 1 ? 'mille' : below1000(thousands) + ' mille');
  }
  if (rest > 0) parts.push(below1000(rest));

  return parts.join(' ').replace(/\s+/g, ' ').trim();
}

/** Formate un montant en euros en toutes lettres : "350" → "trois cent cinquante euros".
 *  Si la partie décimale est non nulle, ajoute " et XX centimes". */
export function montantEnLettres(montant: number): string {
  if (!Number.isFinite(montant)) return '';
  const n = Math.abs(montant);
  const entier = Math.floor(n);
  const centimes = Math.round((n - entier) * 100);
  const eurosTxt = numberToFrenchWords(entier) + ' euro' + (entier > 1 ? 's' : '');
  if (centimes === 0) return eurosTxt;
  return `${eurosTxt} et ${numberToFrenchWords(centimes)} centime${centimes > 1 ? 's' : ''}`;
}
